var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"close-btn",on:{"click":this.closeModal}},[_c('CrossClose')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }